<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div class="charts-section">
	@if (authorizationService.canSee(grants.environmentalImpactApps)) {
		@let worst10Apps = worst10Apps$ | async;

		<div class="chart-panel">
			<globalictcc-chart
				#worst10AppsChart
				chartType="barY"
				[data]="worst10Apps?.data?.chart"
				[isLoading]="worst10Apps?.isLoading ?? true"
				[hasError]="worst10Apps?.hasError || worst10Apps?.data?.hasError"
				[isGradient]="true"
				(handleChartRefresh)="onWorst10AppsChartRefresh()"
			/>

			<div class="chart-actions">
				<globalictcc-button
					label="Export chart"
					[textOnly]="true"
					iconName="download"
					(handleClick)="
						onExportChart(
							worst10AppsChart.instance,
							'software_environmental_impact_apps'
						)
					"
				/>
			</div>
		</div>
	}

	@if (authorizationService.canSee(grants.environmentalImpactLayersPerApp)) {
		@let worst10Layers = worst10Layers$ | async;

		<div class="chart-panel">
			<globalictcc-chart
				#worst10LayersChart
				chartType="barY"
				[data]="worst10Layers?.data?.chart"
				[isLoading]="worst10Layers?.isLoading ?? true"
				[hasError]="worst10Layers?.hasError || worst10Layers?.data?.hasError"
				[isGradient]="true"
				(handleChartRefresh)="onWorst10LayersChartRefresh()"
			/>

			<div class="chart-actions">
				<globalictcc-button
					label="Export chart"
					[textOnly]="true"
					iconName="download"
					(handleClick)="
						onExportChart(
							worst10LayersChart.instance,
							'software_environmental_impact_layers'
						)
					"
				/>
			</div>
		</div>
	}
</div>
